"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestStatusFromAction = requestStatusFromAction;
exports.statusKeyFromAction = statusKeyFromAction;
exports.statusObjectFromRequestStatus = statusObjectFromRequestStatus;

var _fluxStandardAction = require("flux-standard-action");

var _constants = require("../constants");

function requestStatusFromAction(action) {
  var requestStatus = _constants.readyState.IDLE;

  if ((0, _fluxStandardAction.isError)(action) || action.type === _constants.actionTypes.REQUEST_REJECTED) {
    requestStatus = _constants.readyState.REJECTED;
  } else if (action.type === _constants.actionTypes.REQUEST_PENDING) {
    requestStatus = _constants.readyState.PENDING;
  } else if (action.type === _constants.actionTypes.REQUEST_FULFILLED) {
    requestStatus = _constants.readyState.FULFILLED;
  }

  return requestStatus;
}

function statusKeyFromAction(action) {
  switch (action.meta.operationType) {
    case _constants.operationTypes.CREATE:
      return 'createStatus';

    case _constants.operationTypes.READ:
      return 'readStatus';

    case _constants.operationTypes.UPDATE:
      return 'updateStatus';

    case _constants.operationTypes.DELETE:
    default:
      return 'deleteStatus';
  }
}

function statusObjectFromRequestStatus(status) {
  return {
    idle: status === _constants.readyState.IDLE,
    pending: status === _constants.readyState.PENDING,
    fulfilled: status === _constants.readyState.FULFILLED,
    rejected: status === _constants.readyState.REJECTED
  };
}